import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//import Scss (nos styles personnalisés sont importés après react-toastify pour les surcharger)
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';
import { ModalProvider } from './hooks/useModal';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ModalProvider>
        <Route />
        <ToastContainer 
          position="top-right" 
          autoClose={3000} 
          closeButton
          hideProgressBar
          newestOnTop
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </ModalProvider>
    </QueryClientProvider>
  );
}

export default App;
